<!--
  @description 业务拨测-处理任务页
  @author xiehan
  @date 2018/12/04
-->

<template>
  <div class="handlerDial__content">
    <g-back :history="history"></g-back>
    <el-form ref="handlerForm" :model="handlerForm" label-width="90px" :rules="rules" :inline="true">
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.name')" prop="name">
          <el-input v-model="handlerForm.name"></el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.desc')" prop="desc">
          <el-input v-model="handlerForm.desc"></el-input>
        </el-form-item>
      </div>
      <el-form-item :label="$t('dial.frequency')" prop="frequency" input-width="auto">
        <el-radio-group v-model="handlerForm.frequency">
          <el-radio :label="1">{{ $t('dial._1minutes') }}</el-radio>
          <el-radio :label="5">{{ $t('dial._5minutes') }}</el-radio>
          <el-radio :label="15">{{ $t('dial._15minutes') }}</el-radio>
          <el-radio :label="30">{{ $t('dial._30minutes') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.availability')" prop="availability">
          <el-input v-model.number="handlerForm.availability">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.duration')" prop="duration">
          <el-input v-model.number="handlerForm.duration">
            <template slot="append">{{ $t('dial.minutes') }}</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="el-wrap-width">
        <el-form-item :label="$t('dial.trigDelay')" prop="trigDelay">
          <el-input v-model.number="handlerForm.trigDelay">
            <template slot="append">ms</template>
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <dial ref="dial" @testSingleDial="testSingleDial"></dial>
    <div style="margin-top: 16px;">
      <el-form>
        <el-form-item label="Condition" label-width="90px" input-width="570px">
          <el-input
            type="textarea"
            :rows="2"
            v-model="handlerForm.condition">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin: 16px 0 0 90px;">
      <el-button 
        v-text="$t('dial.test')"
        type="primary" 
        @click="testAllDial"
        v-g-rac="gRac('dialEdit_test')"></el-button>
      <el-button 
        v-text="$t('common.save')"
        type="primary" 
        @click="saveDial"
        v-g-rac="gRac('dialEdit_save')"></el-button>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dial from '@/views/component/dial/dial.vue'
  import dialBiz from '@/logic/intelligentMonitor/dialBiz'
  export default {
    mixins: [rac],
    data () {
      return {
        history: [],
        handlerForm: {
          name: '',
          desc: '',
          frequency: 1,
          availability: '',
          duration: '',
          trigDelay: '',
          condition: ''
        },
        rules: {
          name: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.name')}` }
          ],
          desc: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.desc')}` }
          ],
          availability: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.available')}` },
            { type: 'number', message: `${this.$t('dial.available')}${this.$t('dial.mustInt')}` }
          ],
          duration: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.duration')}` },
            { type: 'number', message: `${this.$t('dial.duration')}${this.$t('dial.mustInt')}` }
          ],
          trigDelay: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dial.delay')}` },
            { type: 'number', message: `${this.$t('dial.delay')}${this.$t('dial.mustInt')}` }
          ]
        }
      }
    },
    components: {
      dial
    },
    methods: {
      init () {
        if (this.$route.query.id) {
          dialBiz.getDialById({ id: this.$route.query.id }).then(data => {
            for (let i in this.handlerForm) {
              if (i === 'condition' && data[i]) {
                this.handlerForm[i] = JSON.stringify(data[i])
              } else {
                this.handlerForm[i] = data[i]
              }
            }
            this.$refs.dial.setRequestList(data.requestList)
            this.setHistory(data.name)
          })
        } else {
          this.setHistory()
          this.$refs.dial.resetRequestList()
          this.$refs.handlerForm.clearValidate()
          this.$refs.handlerForm.resetFields()
          this.handlerForm.condition = ''
        }
      },
      setHistory (name) {
        this.history = []
        this.history.push({ name: name || this.$t('dial.addTask') })
      },
      testAllDial () {
        if (this.$refs.dial.getRequestList()) {
          let length = this.$refs.dial.getRequestList().length
          this.testDial(this.$refs.dial.getRequestList(), --length)
        }
      },
      checkCondition () {
        try {
          if (this.handlerForm.condition && typeof JSON.parse(this.handlerForm.condition) !== 'object') {
            this.warningMessage()
            return false
          }
        } catch (err) {
          this.warningMessage()
          return false
        }
        return true
      },
      warningMessage () {
        this.$message({
          message: `condition${this.$t('dial.objectTips')}`,
          type: 'warning'
        })
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      testSingleDial (obj) {
        if (obj.requestInfo) {
          this.testDial([{ ...obj.requestInfo }], obj.requestIndex)
        }
      },
      testDial (requestList, lastRequestIndex) {
        if (this.checkCondition()) {
          let params = {
            condition: this.handlerForm.condition ? JSON.parse(this.handlerForm.condition) : JSON.parse('{}'),
            requestList: requestList
          }
          dialBiz.testall({ ...params }).then(data => {
            if (typeof data === 'object') data = JSON.stringify(data)
            this.$refs.dial.setResponse(lastRequestIndex, data)
            this.successMessage()
          })
        }
      },
      saveDial () {
        this.$refs['handlerForm'].validate((valid) => {
          if (valid && this.checkCondition() && this.$refs.dial.getRequestList()) {
            let params = {
              condition: this.handlerForm.condition ? JSON.parse(this.handlerForm.condition) : JSON.parse('{}'),
              requestList: this.$refs.dial.getRequestList()
            }
            if (this.$route.query.id) {
              this.saveRequest('update', { ...this.handlerForm, ...params, id: this.$route.query.id })
            } else {
              this.saveRequest('save', { ...this.handlerForm, ...params })
            }
          } else {
            return false
          }
        })
      },
      saveRequest (name, params) {
        dialBiz[name](params).then(data => {
          this.successMessage()
          this.$router.push({ name: 'dial' })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerDial' && from.name === 'dial') {
          this.init()
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>